import $ from 'jquery'; 
window.$ = window.jQuery = $;
import introJs from 'intro.js/intro.js';
window.introJs = introJs;
import 'bootstrap';
import 'slick-carousel';
import './inventor/workstream';
import './premium-vendor/text-editor/custom';
import './premium-vendor/text-editor/jquery.sticky';
//import './premium-vendor/text-editor/main'
import './premium-vendor/text-editor/title';
import './premium-vendor/datafilter';
import './premium-vendor/quote';
import '@stripe/stripe-js';
//import './premium-vendor/stripedata';
import './inventor/account';
import {GoogleCharts} from 'google-charts';
import './inventor/chart';
import './components/sign-up';
import './premium-vendor/load-more';
import './account/subscription';
import './components/showcase';
import './components/filter';
import './components/delete';
import './components/blog-filter';
//slick slider initialization
import '../js/slick-slider-init.js';
// ninja slider
import '../js/ninja-slider.js';
// signup step form
import '../js/signup-step.js';
// filter initializations
import '../js/filter.js';
// Showmore text initializations
import '../js/showmore.js';
// select 2 sources
import '../js/select2.min.js';
// select 2 initializations
import '../js/autoload.js';

// admin scripts
import '../js/admin/theme.js';
import '../js/admin/chartjs.js';
import '../js/admin/feather.js';
import '../js/admin/flatpickr.js';
import '../js/admin/data-table.js';
import '../js/admin/sidebar.js';
import '../js/admin/admin-main.js';
import '../js/admin/review-data.js';

